import React from "react";

export const getLeadStatusClass = (status) => {
  const statusClassMap = {
    "E-sign completed": "status-esign-completed",
    Elected: "status-elected",
    Declined: "status-declined",
    "Enrollment Question": "status-enrollment-question",
    "Paycheck Illustration viewed": "status-paycheck-viewed",
    "Logged in and reviewing": "status-logged-reviewing",
    "Not logged in": "status-not-logged-in",
  };

  return statusClassMap[status] || "status-default";
};

export const LEAD_DETAILS_COLUMNS = [
  {
    title: "Lead Name",
    dataIndex: "name",
    key: "name",
    render: (text) => <span className="text-capitalize">{text}</span>,
  },
  {
    title: "Lead Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Lead Phone number",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Lead Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span className={`lead-status-badge ${getLeadStatusClass(status)}`}>
        {status}
      </span>
    ),
  },
];

export const LEAD_STATUS_OPTIONS = [
  { value: "E-sign completed", label: "E-sign completed" },
  { value: "Elected", label: "Elected" },
  { value: "Declined", label: "Declined" },
  { value: "Enrollment Question", label: "Enrollment Question" },
  {
    value: "Paycheck Illustration viewed",
    label: "Paycheck Illustration viewed",
  },
  { value: "Logged in and reviewing", label: "Logged in and reviewing" },
  { value: "Not logged in", label: "Not logged in" },
];
